if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          axButtonOpen: this.querySelector('.product__media__thumbnail-btn [data-target]'),
        };

        this.mql = window.matchMedia('(min-width: 768px)');
        
        // Toujours écouter slideChanged pour la gestion du sticker, même sans thumbnails
        if (this.elements.viewer) {
          this.elements.viewer.addEventListener(
            'slideChanged',
            debounce(this.onSlideChanged.bind(this), 500),
          );
        }
        
        if (!this.elements.thumbnails) return;
        
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener(
              'click',
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false),
            );
        });
        this.elements.axButtonOpen?.addEventListener(
          'click',
          this.setActiveMedia.bind(this, this.elements.axButtonOpen.dataset.target, false),
        );
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches)
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        // Handle thumbnails only if they exist (desktop mode)
        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
          );
          this.setActiveThumbnail(thumbnail);
        }
      }

      setActiveMedia(mediaId, prepend) {
        const buttonMobile = this.elements.viewer.querySelector(
          '.slider-group-button .product__media-zoom-mobile-hover',
        );
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

        if (!prepend) {
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          activeMedia.classList.add('is-active');

          this.preventStickyHeader();
          window.setTimeout(() => {
            if (this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
            if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
              activeMedia.scrollIntoView({ behavior: 'smooth' });
            }
          });
          this.playActiveMedia(activeMedia);
        }

        // Toujours mettre à jour les thumbnails, même lors des changements de variantes
        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`,
        );

        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
        }

        if (!prepend) {
          this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        // Force le repaint pour garantir la mise à jour visuelle
        thumbnail.offsetHeight;
        thumbnail.querySelector('button').style.transform = 'translateZ(0)';
        setTimeout(() => {
          thumbnail.querySelector('button').style.transform = '';
        }, 10);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 0)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
            '[index]',
            position,
          );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation'),
        );
      }
    },
  );
}
